import React, { memo } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import cn from 'classnames';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { colors, fontSize } from '../../../constants/styleConstants';
import TabIcon from '../../../public/images/tab.svg';
import ActiveTabIcon from '../../../public/images/tab_active.svg';
import FbTabs from '../../FbTabs';
import { EditLayoutHeader } from './EditLayoutHeader';

const useStyles = makeStyles(() => ({
  appBar: {
    backgroundColor: colors.background.grayLight,
    borderBottom: 'none',
  },
  tabRoot: {
    padding: '20px 15px',
    paddingRight: 34,
    borderBottom: '1px solid rgba(151,151,151,0.5)',
    color: colors.secondaryTitleColor,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center right 10px',
    textTransform: 'none',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  tabRootFilled: {
    backgroundImage: `url(${TabIcon})`,
  },
  selectedFilledTab: {
    backgroundImage: `url(${ActiveTabIcon})!important`,
  },
  tabWrapper: {
    display: 'block',
    textAlign: 'left',
    fontSize: fontSize.basic,
    wordBreak: 'break-word',
    lineHeight: 1,
  },
  selectedTab: {
    backgroundColor: colors.blueLight,
    color: `${colors.white}!important`,
    fontWeight: 'bold',
  },
  tabIndicator: {
    backgroundColor: 'inherit',
  },
  tab: {
    minWidth: 'auto !important',
  },
}));

export function EditLayout({ tabs, selectedTab, goToTab }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();

  const getTabs = Object.values(tabs).map(tab => ({
    ...tab,
    classes: {
      root: cn(classes.tabRoot, { [classes.tabRootFilled]: Boolean(tab.isFilled) }),
      selected: cn(classes.selectedTab, {
        [classes.selectedFilledTab]: Boolean(tab.isFilled),
      }),
    },
  }));

  return (
    <Grid container spacing={3} alignItems="stretch">
      <Grid item lg={3} sm={3} xs={12}>
        <FbTabs
          tabs={getTabs}
          initialTabValue={selectedTab?.value}
          value={selectedTab?.value}
          onChange={v => goToTab(v)}
          orientation={isMobile ? 'horizontal' : 'vertical'}
          appBarClass={classes.appBar}
          tabsClasses={{
            indicator: classes.tabIndicator,
          }}
          tabClasses={{
            root: classes.tab,
            wrapper: classes.tabWrapper,
          }}
        />
      </Grid>
      <Grid item lg={9} sm={9} xs={12}>
        {(selectedTab?.title || selectedTab?.subtitle) && (
          <EditLayoutHeader title={selectedTab?.title} subtitle={selectedTab?.subtitle} actions={selectedTab.actions} />
        )}
        {selectedTab?.form}
      </Grid>
    </Grid>
  );
}

EditLayout.propTypes = {
  tabs: PropTypes.object.isRequired,
  selectedTab: PropTypes.object.isRequired,
  goToTab: PropTypes.func,
};

EditLayout.defaultProps = {
  goToTab: () => {},
};

export default memo(EditLayout);
